import React, { useState } from "react";
import style from "./custominput.module.css";

interface CustomInputProps {
  label: string;
  onChange: (updatedField: { label: string; value: string }) => void;
  value: string;
}

const InputType: any = {
  name: "text",
  email: "email",
  PhoneNumber: "number",
  Company: "text",
};

export const CustomInput: React.FC<CustomInputProps> = ({
  label,
  onChange,
  value,
}) => {
  const [isValid, setIsValid] = useState(true);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let updatedValue = e.target.value;
    if (label !== "name" && label !== "city") {
      updatedValue = updatedValue.trim();
    }
    
    if (label === "PhoneNumber") {
      updatedValue = updatedValue.replace(/\D/g, "").slice(0, 10);
      setIsValid(updatedValue.length === 10);
    }
    if (label === "email") {
      updatedValue = updatedValue.replace(/\s/g, "");
      const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
      setIsValid(emailRegex.test(updatedValue));
    }
    if (label === "benId") {
      updatedValue = updatedValue.slice(0, 24);
    }

    // City: Only alphabets and spaces
    if (label === "city") {
      updatedValue = updatedValue.replace(/[^a-zA-Z\s]/g, ""); // Remove digits/special chars
    }

    // Pincode: Only digits, max 6
    if (label === "pinCode") {
      updatedValue = updatedValue.replace(/\D/g, ""); // Remove non-digits
      updatedValue = updatedValue.slice(0, 6);
    }

    onChange({ label, value: updatedValue });
  };

  return (
    <>
      <div>
        <div>
          <label>{`${label}`}</label>
        </div>
        <div>
          <input
            className={`${style.input} ${!isValid ? style.invalid_Border : ""}`}
            placeholder={`Enter ${label}`}
            type={InputType[label]}
            value={value}
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  );
};
